import { orderBy, find, union, chunk } from 'lodash';
import Model from 'mixins/model';
import CommentModel from 'models/CommentModel';

export class CommentsCollection extends Model {
    constructor() {
        super();

        this.set('comments', []);
        this.set('recommended', 0);
        this.set('pageSize', 50);

        return this;
    }

    getPage(number) {
      return chunk(this.get('comments'), this.get('pageSize'))[number];
    }

    add(item) {
        this.get('comments').push(item);
        if (item.get('isRecommended')) {
            this.set('recommended', this.get('recommended')+1);
        }
        this.set('news', this.get('news') + 1);
        this.fireEvent('added', item);
    }

    update(model) {
        const comment = this.findById(model.get('id'));
        if (comment) {
            comment.update(model);
        } else {
            throw Error(`You are trying to reply to or edit non-existing comment.`);
        }
    }

    updatePendingRepliesCounter(data) {
        if (data.base) {
            this.fireEvent('updatedPendingRepliesCounter', data.base);
        }
        for (const item in data.replies) {
            const model = this.findById(item);
            if (model) {
                model.fireEvent('updatedPendingRepliesCounter', data.replies[item]);
            }
        }
    }

    addReply(model) {
        const parentModel = find(
            this.get('comments'),
            object => object.get('id') === model.get('parentCommentId')
        );
        parentModel.get('replies').push(model);
        parentModel.fireEvent('changed');
    }

    clear() {
        this.get('comments').forEach((model) => {
            model.destroy();
        });
        this.set('comments', []);
        this.fireEvent('cleared');
    }

    getBaseComment(model) {
        const parentCommentId = model.get('parentCommentId');
        let result;

        if (parentCommentId === null) {
            result = model;
        } else {
            const baseModel = find(this.get('comments'), (item) => item.get('id') === parentCommentId);
            result = baseModel;
        }

        return result;
    };

    findById(id) {
        const comments = this.get('comments');
        let result = find(comments, (model) => model.get('id') === parseInt(id));

        if (!result) {
            let replies = [];
            comments.forEach((model) => {
                replies = union(replies, model.get('replies'));
            });
            result = find(replies, (model) => model.get('id') === parseInt(id));
        }

        return result;
    }

    findBaseCommentById(id) {
        const comments = this.get('comments');
        return find(comments, (model) => model.get('id') === parseInt(id));
    }

    addComments(data = []) {
        const newModels = [];
        const currentCommentsIds = this.get('comments').map(item => item.get('id'));
        data.filter(item => {
            return currentCommentsIds.indexOf(item.id) === -1;
        }).forEach(item => {
          const model = CommentModel.fromJSON(item)
          newModels.push(model);
        });

        newModels.forEach((model) => {
          this.get('comments').push(model);
        });

        this.fireEvent('commentsAdded', newModels);
    }

    fromJSON(data = []) {
        const commentsArray = [];

        let recommendedCount = 0;
        let newCount = 0;

        data.forEach(item => {
          const model = CommentModel.fromJSON(item);
          commentsArray.push(model);

          if (model.get('isRecommended')) {
              recommendedCount++;
          }
          if (model.get('isNew')) {
              newCount++;
          }
        });

        this.clear();
        this.set('comments', commentsArray);
        this.set('recommendedCount', recommendedCount);
        this.set('newCount', newCount);
        this.fireEvent('changed');
    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/models/CommentsCollection.js